import { useState, useCallback } from 'react'
import { ActivityLogEntry } from '../data/types'

const initialLogs: ActivityLogEntry[] = [
  {
    id: 'log-1',
    type: 'request',
    message: "L'Oréal accepted your booking invitation",
    detail: 'Week 4 · Sandton City + 2 more',
    timestamp: new Date(Date.now() - 1000 * 60 * 15).toISOString(),
    read: false,
  },
  {
    id: 'log-2',
    type: 'artwork',
    message: 'Artwork uploaded for Estée Lauder',
    detail: 'Winter Skincare Campaign · Week 3',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(),
    read: false,
  },
  {
    id: 'log-3',
    type: 'booking',
    message: 'New draft campaign created',
    detail: 'Skoon · Week 1 · 4 stores',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(),
    read: true,
  },
  {
    id: 'log-4',
    type: 'slot-change',
    message: 'Inventory blocked',
    detail: 'V&A Waterfront · Digital Windows · Week 5',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 48).toISOString(),
    read: true,
  },
  {
    id: 'email-1',
    type: 'email',
    message: 'Booking invitation sent',
    detail: 'Prestige Cosmetics · Summer Launch · Week 2',
    timestamp: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
    read: true,
    emailTo: 'jane@prestige.co.za',
    emailSubject: 'Woolworths Media Booking Invitation — Summer Launch',
  },
  {
    id: 'email-2',
    type: 'email',
    message: 'Booking confirmation sent',
    detail: "L'Oréal · Week 4 · Sandton City",
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 3).toISOString(),
    read: true,
    emailTo: 'media@loreal.co.za',
    emailSubject: 'Woolworths Booking Confirmed — Week 4',
  },
]

export function useActivityLog() {
  const [entries, setEntries] = useState<ActivityLogEntry[]>(initialLogs)

  const unreadCount = entries.filter(
    (e) => !e.read && e.type !== 'email',
  ).length

  const markAsRead = useCallback((id: string) => {
    setEntries((prev) =>
      prev.map((entry) => (entry.id === id ? { ...entry, read: true } : entry)),
    )
  }, [])

  const markAllAsRead = useCallback(() => {
    setEntries((prev) => prev.map((entry) => ({ ...entry, read: true })))
  }, [])

  const addLog = useCallback(
    (entry: Omit<ActivityLogEntry, 'id' | 'timestamp' | 'read'>) => {
      const newEntry: ActivityLogEntry = {
        ...entry,
        id: `log-${Date.now()}`,
        timestamp: new Date().toISOString(),
        read: false,
      }
      setEntries((prev) => [newEntry, ...prev])
    },
    [],
  )

  const addEmailLog = useCallback(
    (to: string, subject: string, message: string, detail?: string) => {
      const newEntry: ActivityLogEntry = {
        id: `email-${Date.now()}`,
        type: 'email',
        message,
        detail,
        timestamp: new Date().toISOString(),
        read: true,
        emailTo: to,
        emailSubject: subject,
      }
      setEntries((prev) => [newEntry, ...prev])
    },
    [],
  )

  return {
    entries,
    unreadCount,
    markAsRead,
    markAllAsRead,
    addLog,
    addEmailLog,
  }
}
